import { Button, Icon } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'

type ActionButtons = {
  onSubmit?: () => void
  onClear?: () => void
}

const ActionButtons = ({ onSubmit, onClear }: ActionButtons) => {
  const { t } = useTranslation()
  return (
    <div className='col-md-2 align-self-end filterFields-action-buttons'>
      <label>{t('action-buttons.actions')}</label>

      <div className='row d-md-none'>
        <div className='col-6'>
          <Button type='submit' onClick={onSubmit}>
            {t('action-buttons.submit')}
          </Button>
        </div>
        <div className='col-6'>
          <Button type='button' variant='secondary' onClick={onClear}>
            {t('action-buttons.clear')}
          </Button>
        </div>
      </div>

      <div
        className='d-none d-md-grid'
        style={{
          gridAutoColumns: '36px',
          gridAutoFlow: 'column',
          gap: '0.25rem'
        }}
      >
        <Button
          type='submit'
          onClick={onSubmit}
          title={t('action-buttons.submit')}
          className='d-flex align-items-center justify-content-center'
        >
          <Icon iconName='Filters' icSize='small' />
        </Button>
        <Button
          type='button'
          variant='secondary'
          onClick={onClear}
          title={t('action-buttons.clear')}
        >
          <Icon iconName='Rubber' icSize='regular' />
        </Button>
      </div>
    </div>
  )
}

export default ActionButtons
